module.exports = "<div class=\"br-busy\">  \n  <ng-content></ng-content>\n  <div [ngBusy]=\"busyCfg\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/ui/indicator/indicator.component.html
// module id = ../../../../../src/app/shared/ui/indicator/indicator.component.html
// module chunks = 10